import ApiService from '@/services/core/api.service'

const CommentService = {
  async get (payment, params = {}) {
    return ApiService.get(`executive-secretary/check-approvals/${payment}/comments`, { params })
  },

  async post (payment, payload) {
    return ApiService.post(`executive-secretary/check-approvals/${payment}/comments`, payload)
  },

  async put (payment, payload) {
    return ApiService.put(`executive-secretary/check-approvals/${payment}/comments/${payload.id}`, payload)
  },

  async delete (payment, payload) {
    return ApiService.delete(`executive-secretary/check-approvals/${payment}/comments/${payload.id}`, {
      data: payload
    })
  }
}

export default CommentService
